    <div [@routerTransition] [busyIf]="isLoading" id="my-profile-component" class="myprofile_wrappern pb-4 pt-4 p-4 h-100">

    <div class="container-fluid p-2">
        <div class="my-profile-content">
            <div class="my-profile-header">
                <h6>
                    <b> {{"MyProfile" | localize}}</b>
                </h6>
                <small>
                    {{'UpdateyourpersonalInformation' | localize}}
                </small>
            </div>
            <div class="my-profile-body p-2">

                <form #myProfileForm="ngForm" id="myProfileForm" novalidate>
                    <div class="row">
                        <div class="col-md-2 col-lg-2 col-xl-2 pl-0">
                            <div class="form-group">
                                <div class="image-input-wrapper profile-pic-wrapper ">
                                    <div *ngIf="showImg">
                                        <img class=" img-fluid rounded" style="width: 110px;height: 110px;"
                                            [src]=" imagePath? imagePath : 'assets/common/images/default-profile-picture1.svg'" />
                                    </div>
                                    <div *ngIf=" !imagePath ">
                                        <label class="mt-3 ml-1" title="" data-original-title="Change avatar"
                                         a href=""  (click)="showSideBar()">
                                            <a class="blue cursor-pointer">
                                                {{'UploadPhoto' | localize}} {{imagePath}}
                                            </a>
                                        </label>
                                    </div>
                                    <div *ngIf=" imagePath">
                                        <label class="mt-3" (click)="deletePicture()" data-toggle="tooltip"
                                            [style.display]="imagePath === '' ? 'none' : ''" title="">
                                            <a class="blue cursor-pointer ml-3">
                                                {{'RemovePhoto' | localize}}
                                            </a>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-9 col-xl-9 col-lg-9">
                            <div class="row">

                                <div class="col-md-6 col-xl-6 col-lg-6">
                                    <label>{{'FirstName' | localize}}<span class="required text-danger">*</span>
                                    </label>
                                    <input class="form-control rounded-0" type="text" name="firstName"
                                        #firstName="ngModel" [(ngModel)]="myProfileData.firstName"
                                        placeholder="{{'EnterFirstName' | localize}}" value=""
                                        [ngClass]="{'borderRed ' : myProfileForm.submitted && firstName.invalid}"
                                        maxlength="25" autocomplete="nope" required>
                                    <div *ngIf="myProfileForm.submitted" class="text-danger">

                                        <span *ngIf="firstName.invalid && firstName.errors.required">
                                            {{'Firstnameismandatory' | localize}}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-md-6 col-xl-6 col-lg-6">
                                    <label>{{'LastName' | localize}}<span class="required text-danger">*</span> </label>
                                    <input class="form-control rounded-0" type="text" #lastName="ngModel"
                                        placeholder="{{'EnterLastName' |localize }}"
                                        [(ngModel)]="myProfileData.lastName"
                                        [ngClass]="{'borderRed ' : myProfileForm.submitted && lastName.invalid}"
                                        maxlength="25" autocomplete="nope" name="lastName" required>
                                    <div *ngIf="myProfileForm.submitted" class="text-danger">
                                        <span *ngIf="lastName.invalid && lastName.errors.required">
                                            {{'Lastnameismandatory' | localize}}
                                        </span>

                                        <span *ngIf="lastName.errors?.maxlength">
                                            {{'Lastnamecannotbegreaterthancharacters' | localize}}
                                        </span>

                                    </div>
                                </div>

                                <div class="col-md-6  col-xl-6 col-lg-6 mt-3">
                                    <div class="">
                                        <label> {{'EmailID' | localize}}<span
                                                class="required text-danger">*</span></label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text rounded-0">
                                                    <i class="flaticon-email"></i>
                                                </span>
                                            </div>
                                            <input class="form-control rounded-0" id="EmailAddress" type="email"
                                                name="emailAddress" #emailAddressInput="ngModel" disabled="disabled"
                                                [(ngModel)]="myProfileData.emailAddress" maxlength="256" email>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-xl-6 col-lg-6 mt-3">
                                    <div class="">
                                        <label> {{'EmployeeId' | localize}}</label>
                                        <div class="input-group">
                                            <input class="form-control rounded-0" id="empId" type="text"
                                                name="empId" #emailAddressInput="ngModel" disabled="disabled"
                                                [(ngModel)]="myProfileData.employeeId" maxlength="256">
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="isSocial" class="col-md-12 mt-3">
                                    <div class="">
                                        <div *ngIf="showPassword">
                                            <label>{{'CurrentPassword' | localize}}</label>
                                            <div class="input-group">
                                                <input id="CurrentPassword" #currentPasswordInput="ngModel"
                                                    value="currentPasswordInput" type="password" name="CurrentPassword"
                                                    placeholder="{{'CurrentPassword' | localize}}"
                                                    class="form-control rounded-0"
                                                    [ngClass]="{'borderRed ' : incorrectCurrentPassword || (currentPasswordInput.touched && currentPasswordInput.errors?.required)}"
                                                    [type]="fieldTextType ? 'password' : 'text'" autocomplete="off"
                                                    [(ngModel)]="currentPassword"
                                                    (ngModelChange)="currentPasswordChanged()" required>
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text rounded-0">
                                                        <i class="fa cursor-pointer"
                                                            [ngClass]="{'fa-eye-slash': fieldTextType,'fa-eye': !fieldTextType}"
                                                            (click)="toggleFieldTextType()"></i>
                                                    </span>
                                                </div><br>
                                            </div>
                                            <div *ngIf="incorrectCurrentPassword">
                                                <span class="my-profile-password-change-validation">
                                                    {{'MyProfileIncorrectCurrentPassword' | localize}}
                                                </span>
                                            </div>
                                            <div
                                                *ngIf="currentPasswordInput.touched && currentPasswordInput.errors?.required">
                                                <span class="my-profile-password-change-validation">
                                                    {{'CurrentPasswordismandatory' | localize}}
                                                </span>
                                            </div>
                                            <div *ngIf="myProfileForm.submitted" class="invalid-feedback">
                                                <span
                                                    *ngIf="currentPasswordInput.invalid && currentPasswordInput.touched">
                                                    {{'ThisFieldIsRequired' | localize}}
                                                </span>
                                            </div>
                                            <div *ngIf="myProfileForm.submitted" class="invalid-feedback">
                                                <span *ngIf="!iscurrentPassword && currentPasswordInput.touched">
                                                    {{'Invalidcurrentpassword' | localize}}
                                                </span>
                                            </div>
                                        </div>
                                        <div *ngIf="isSocial">
                                            <div class="" *ngIf="!showPassword">
                                                <a (click)="showPassword =!showPassword"
                                                    class="blue cursor-pointer">{{'ChangePassword' | localize}}</a>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div class="col-md-12 col-xl-12 col-lg-12 mb-1 mt-2">
                                    <div class="">
                                        <label> {{'Reporting Manager' | localize}}</label>
                                        <div class="input-group">

                                            <input class="form-control rounded-0" id="empName" type="text"
                                                name="empName" #emailAddressInput="ngModel" disabled="disabled"
                                                [(ngModel)]="myProfileData.managerName" maxlength="256">
                                        </div>
                                    </div>
                                </div>

                                    <div *ngIf="isSocial" class="col-md-12 col-xl-12 col-lg-12 mt-3">

                                        <div class="" *ngIf="showPassword">

                                            <div class="input-group">

                                                <input id="NewPassword" name="NewPassword"
                                                       class="form-control rounded-0" #NewPassword="ngModel"
                                                       [type]="fieldTextTypeNewPassword ? 'password' :'text'"
                                                       autocomplete="off" [(ngModel)]="newPassword"
                                                       placeholder="{{'NewPassword' | localize}}"
                                                       validateEqual="NewPasswordRepeat" reverse="true"
                                                       [requireDigit]="true" [requireUppercase]="true"
                                                       [requireLowercase]="true" [requireNonAlphanumeric]="true" [requiredLength]="6"
                                                       [ngClass]="{'borderRed ' : NewPassword.touched && NewPassword.errors?.required}"
                                                       required>

                                                <div class="input-group-prepend">
                                                    <span class="input-group-text rounded-0">
                                                        <i class="fa cursor-pointer"
                                                           [ngClass]="{'fa-eye-slash': fieldTextTypeNewPassword,'fa-eye': !fieldTextTypeNewPassword}"
                                                           (click)="toggleFieldTextTypeNewPassword()"></i>
                                                    </span>
                                                </div>

                                            </div>

                                            <div *ngIf="NewPassword.touched && NewPassword.errors?.required">
                                                <span class="my-profile-password-change-validation">
                                                    {{'MyProfileNewPasswordIsRequired' | localize}}
                                                </span>
                                            </div>

                                            <div [hidden]="myProfileForm.form.valid || myProfileForm.form.pristine">
                                                <ul class="form-text text-danger" *ngIf="NewPassword.errors">
                                                    <li [hidden]="!NewPassword.errors.requireDigit">
                                                        {{
"PasswordComplexity_RequireDigit_Hint" |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li [hidden]="!NewPassword.errors.requireLowercase">
                                                        {{"PasswordComplexity_RequireLowercase_Hint" | localize}}
                                                    </li>
                                                    <li [hidden]="!NewPassword.errors.requireUppercase">
                                                        {{"PasswordComplexity_RequireUppercase_Hint" | localize}}
                                                    </li>
                                                    <li [hidden]="!NewPassword.errors.requireNonAlphanumeric">
                                                        {{"PasswordComplexity_RequireNonAlphanumeric_Hint" | localize}}
                                                    </li>
                                                    <li [hidden]="!NewPassword.errors.requiredLength">
                                                        {{"PasswordComplexity_RequiredLength_Hint" | localize:6}}
                                                    </li>

                                                </ul>
                                            </div>

                                        </div>

                                    </div>

                                <div *ngIf="isSocial" class="col-md-12 col-xl-12 col-lg-12  mt-3">
                                    <div class="" *ngIf="showPassword">

                                        <div class="input-group">

                                            <input id="NewPasswordRepeat" name="NewPasswordRepeat"
                                                class="form-control rounded-0" #NewPasswordRepeat="ngModel"
                                                [type]="fieldTextTypeNewPasswordConfirm ? 'password' :'text'"
                                                [(ngModel)]="confirmPassword"
                                                placeholder="{{'ConfirmNewPassword' | localize}}"
                                                validateEqual="NewPassword" reverse="false" autocomplete="off"
                                                [requireDigit]="passwordComplexitySetting.requireDigit"
                                                [requireLowercase]="passwordComplexitySetting.requireLowercase"
                                                [requireUppercase]="passwordComplexitySetting.requireUppercase"
                                                [requireNonAlphanumeric]="passwordComplexitySetting.requireNonAlphanumeric"
                                                [ngClass]="{'borderRed ' : (NewPasswordRepeat.touched && NewPasswordRepeat.errors?.required)|| (!(myProfileForm.form.valid || myProfileForm.form.pristine)&& ((NewPasswordRepeat.errors && NewPasswordRepeat.touched && myProfileForm.submitted)&& !(NewPasswordRepeat.touched && NewPasswordRepeat.errors?.required)))}"
                                                [requiredLength]="passwordComplexitySetting.requiredLength" required>
                                            <div class="input-group-prepend">
                                                <span class="input-group-text rounded-0">
                                                    <i class="fa cursor-pointer"
                                                        [ngClass]="{'fa-eye-slash': fieldTextTypeNewPasswordConfirm,'fa-eye': !fieldTextTypeNewPasswordConfirm}"
                                                        (click)="toggleFieldTextTypeNewPasswordConfirm()"></i>
                                                </span>
                                            </div>

                                        </div>
                                        <div *ngIf="NewPasswordRepeat.touched && NewPasswordRepeat.errors?.required">
                                            <span class="my-profile-password-change-validation">
                                                {{'MyProfileConfirmNewPasswordIsRequired' | localize}}
                                            </span>
                                        </div>
                                        <div [hidden]="myProfileForm.form.valid || myProfileForm.form.pristine">
                                            <span
                                                *ngIf="(NewPasswordRepeat.errors && NewPasswordRepeat.touched && myProfileForm.submitted)&& !(NewPasswordRepeat.touched && NewPasswordRepeat.errors?.required)"
                                                class="my-profile-password-change-validation">
                                                {{'PasswordsDontMatch' | localize}}
                                            </span>
                                        </div>

                                    </div>
                                </div>

                                <div class="col-md-12 col-lg-12 col-xl-12">
                                    <div class=" mt-2" *ngIf="showPassword">
                                        <a (click)="showPassword =!showPassword" class="cursor-pointer anchor-color">
                                            {{'Cancel' | localize}}
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </form>

                <div class="my-profile-integrations-row">
                    <app-profile-integrations style="display: block; width: 100%;"></app-profile-integrations>
                </div>

                <div class="footer mt-1">
                    <div class="d-flex justify-content-end mb-2">
                        <div class="actions">
                            <button type="button" class="btn btn-square btn-outline-danger px-3 mr-1"
                                (click)="close()">
                                {{"Cancel" | localize}}
                            </button>
                            <button type="submit" class="btn btn-square btn-primary px-4"
                                [buttonBusy]="saving" [busyText]="l('SavingWithThreeDot')"
                                [disabled]="!isImage && myProfileForm.form.pristine"
                                form="myProfileForm" (click)="save()">
                                {{"Save" | localize}}
                            </button>
                        </div>
                    </div>
                </div>

                <user-menu style="display:none" #topBarComponentData></user-menu>
            </div>

            <p-drawer #photoDrawer
                [(visible)]="isSidebarOpen"
                [blockScroll]="false"
                position="right"
                appendTo="body"
                styleClass="p-sidebar-md p-sidebar-bottom my-profile-photo-drawer"
                id="ClientProfileModal"
                (onHide)="onPhotoDrawerHide()">
                <div class="photo-drawer">
                    <div class="photo-drawer__header">
                        <div class="photo-drawer__tabs" role="tablist">
                            <button type="button"
                                role="tab"
                                class="photo-drawer__tab"
                                [class.active]="tabIndex === 1"
                                (click)="onKey(1)">
                                {{'UploadanImage' | localize}}
                            </button>
                            <button type="button"
                                role="tab"
                                class="photo-drawer__tab"
                                [class.active]="tabIndex === 2"
                                (click)="onKey(2)">
                                {{'SelectanAvatar' | localize}}
                            </button>
                        </div>
                        <button type="button"
                            class="photo-drawer__close"
                            (click)="cancelPhoto()"
                            aria-label="Close"
                            [disabled]="isFileLoading">
                            <i aria-hidden="true" class="ki ki-close"></i>
                        </button>
                    </div>

                    <div class="photo-drawer__body">
                        <div class="photo-drawer__pane" *ngIf="tabIndex === 1">
                            <div class="photo-drawer__dropzone">
                                <div *ngIf="isFileLoading" class="photo-drawer__loading">
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <p>{{'Processing' | localize}}</p>
                                </div>

                                <ng-container *ngIf="!isFileLoading && showImgModal">
                                    <img *ngIf="imagePathModal !== ''"
                                        class="photo-drawer__preview"
                                        [src]="imagePathModal"
                                        alt="">
                                    <img *ngIf="imagePathModal === ''"
                                        class="photo-drawer__preview"
                                        src="assets/common/images/default-profile-picture1.svg"
                                        alt="">
                                    <button type="button" class="photo-drawer__text-action" (click)="removeImage()">
                                        {{'RemovePhoto' | localize}}
                                    </button>
                                </ng-container>

                                <label *ngIf="!isFileLoading && !showImgModal" class="photo-drawer__upload-trigger">
                                    <input #fileInput
                                        type="file"
                                        id="UploadFile"
                                        (change)="getfileContent($event.target.files)"
                                        name="profile_avatar"
                                        accept=".png, .jpg, .jpeg"
                                        required>
                                    <span class="photo-drawer__link">{{'ClickHere' | localize}}</span>
                                    <span class="photo-drawer__hint">{{'Touploadyourphoto' | localize}}</span>
                                </label>

                                <p class="photo-drawer__meta">{{'RecommendedFormat' | localize}}</p>
                                <p class="photo-drawer__meta">{{'RecommendedSize' | localize}}</p>
                            </div>

                            <div class="photo-drawer__actions">
                                <button type="button"
                                    class="btn btn-square btn-outline-danger"
                                    (click)="cancelPhoto()"
                                    [disabled]="isFileLoading">
                                    {{'Cancel' | localize}}
                                </button>
                                <button type="button"
                                    class="btn btn-square btn-primary"
                                    (click)="savePhoto()"
                                    [disabled]="!imagePathModal || isFileLoading">
                                    {{'Upload' | localize}}
                                </button>
                            </div>
                        </div>

                        <div class="photo-drawer__pane" *ngIf="tabIndex === 2">
                            <p class="photo-drawer__avatar-intro">{{'Chooseanavatarforyourprofile' | localize}}</p>
                            <div class="photo-drawer__avatars">
                                <button type="button"
                                    *ngFor="let c of photoImage; let i = index"
                                    class="photo-drawer__avatar"
                                    [class.highlight-avatar]="selectedAvatarIndex === i"
                                    (click)="selectIcon(c.icon, i)">
                                    <img [src]="c.icon" [id]="'Img' + i" alt="">
                                </button>
                            </div>
                            <div class="photo-drawer__actions">
                                <button type="button"
                                    class="btn btn-square btn-outline-danger"
                                    (click)="deletePicture()">
                                    {{'Cancel' | localize}}
                                </button>
                                <button type="button"
                                    class="btn btn-square btn-primary"
                                    (click)="savePhoto()"
                                    [disabled]="!imagePathModal">
                                    {{'Upload' | localize}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </p-drawer>
        </div>
    </div>
</div>
